import { render } from "./PatientNav.vue?vue&type=template&id=a241e1ca"
import script from "./PatientNav.vue?vue&type=script&lang=js"
export * from "./PatientNav.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__